import { providerSchema } from '@billing/validation/provider';
import type { Province } from '@billing/validation/payor';
import { Site } from './site';
import { User } from './user';
import { Specialty } from './specialty';
import { Payor } from './payor';
import { Group } from './group';

export interface License {
  payorID: string;
  license: string;
  payorName: string;
  siteID: string;
  payor: Payor;
}

export interface Provider {
  id: string;
  firstName: string;
  lastName: string;
  email: string | null;
  contactNote: string | null;
  license: string;
  province: Province | null;
  specialtyCode: string;
  specialtyStartDate: string;
  userID: string | null;
  user: User | null;
  title: string | null;
  sites: Site[] | null;
  siteID: string | null;
  licenses: License[] | null;
  specialty: Specialty | null;
  groups: Group[];
  createdAt: string;
  updatedAt: string | null;
}
export type FormProvider = Omit<Provider, 'id'>;

export const isProvider = (obj: any): obj is Provider => {
  return providerSchema.safeParse(obj).success;
};
